module.exports = __webpack_public_path__ + "static/media/r7.6cc4e97b.png";